import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/main.scss';
import { RouterProvider } from "react-router-dom";

import router from './utils/router.jsx';

ReactDOM.createRoot(document.getElementById('root')).render( <RouterProvider router={router} /> );
